import {config} from "../constants";
import {AuthService} from "../../screens/auth/service/auth-service";

export class SearchService {
    search = async (phrase, projectId) => {
        let endpoint = config.genericService + "/search/all?phrase=" + encodeURIComponent(phrase);
        if (projectId) endpoint += "&projectId=" + encodeURIComponent(projectId);
        const token = await AuthService.getIdTokenOfCurrentUser();
        if (!token) return null;
        return fetch(endpoint, {
            headers: { 'Authorization': 'Bearer ' + token },
            mode: 'cors',
        }).then(r => r.json()).catch(() => null);
    };
}
